import {Component, OnInit} from '@angular/core';
import {BankService} from "../services/bank.service";
import {Router} from "@angular/router";
import {PagerserviceService} from "../services/pagerservice.service";
import {NotificationsService} from "angular2-notifications";
import {AssetsService} from "../services/assets.service";
import {UserService} from "../services/user.service";
import {PuserserviceService} from "../services/puserservice.service";
import {AnnouncementService} from "../services/announcement.service";
import {Globals} from "../app-globals";
import {AdminService} from "../services/admin.service";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";

@Component({
    selector: 'app-announcement',
    templateUrl: './announcement.component.html',
    styleUrls: ['./announcement.component.css']
})

export class AnnouncementComponent implements OnInit {
    viewform = false;
    /*store all transaction list variable*/
    announcementList: Array<any>;
    /* Search variables */
    FilPerpage: number;
    FilPage: number;
    filter: Boolean;
    /************************************/
    // pager Number
    pager: number;
    Tpager: number;

    // pager object
    pager1: any = {};

    //search option
    search = '';
    statusoption = '';
    formObj = {
        title: '',
        body: '',
        type: 'private',
        _csrf: ''
    }
    permission: string;

    /* Hide / show variables */
    TransactionActive:string;

    constructor(private router: Router,
                private assetService: AssetsService,
                private userService: UserService,
                private bankService: BankService,
                private pagerService: PagerserviceService,
                private notifSer: NotificationsService,
                private announceService: AnnouncementService,
                private global: Globals,
                private spinnerService: Ng4LoadingSpinnerService,
                private pusherService: PuserserviceService,
                private adminService: AdminService) {
    }

    ngOnInit() {
        if (!this.userService.isLoggedIn()) {
            this.router.navigateByUrl('/index');
        } else {
            this.adminService.groupupdate.subscribe(permData => {
                localStorage.setItem('permission', permData.permission);
                this.permission = permData.permission
            })
            this.permission = this.adminService.getPermission();
            this.FilPerpage = 10;
            this.FilPage = 1;
            this.pager = 1;
            this.getAnnouncementList();
            this.csrf();
            this.TransactionActive = null;
        }
    }

    csrf() {
        this.userService.csrf().subscribe((success) => {
            this.formObj._csrf = success._csrf;
        }, (error) => {
            this.notifSer.error(
                'Error',
                error.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }

    saveAnnouncement() {
        this.spinnerService.show();
        this.announceService.saveAnnouncement(this.formObj).subscribe((success) => {
            this.getAnnouncementList();
            this.viewform = false;
            this.formObj = {
                title: '',
                body: '',
                type: 'private',
                _csrf: ''
            };
            this.csrf();
            this.notifSer.success(
                'Success',
                'Announcement created',
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
            this.spinnerService.hide();
        }, (error) => {
            this.spinnerService.hide();
            this.csrf();
            this.notifSer.error(
                'Error',
                error.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }

    getAnnouncementList() {
        this.spinnerService.show();
        this.announceService.getAnnouncementList(this.FilPerpage, this.FilPage).subscribe((success) => {
            if (success.status) {
                this.announcementList = success.announcements;
                this.Tpager = success.pages;
                this.setPage(this.FilPage);
            }
            this.spinnerService.hide();
        }, (error) => {
            this.spinnerService.hide();
            this.notifSer.error(
                'Error',
                error.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }

    updateAnnouncementStatus(id, status) {
        this.spinnerService.show();
        this.announceService.changeAnnouncementStatus(id, status).subscribe(done => {
            this.getAnnouncementList();
            this.notifSer.success(
                'Success',
                done.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
            this.spinnerService.hide();
        }, (error) => {
            this.spinnerService.hide();
            this.notifSer.error(
                'Error',
                error.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }

    deleteAnnouncement(id) {
        this.spinnerService.show();
        this.announceService.delete(id).subscribe(done => {
            this.getAnnouncementList();
            this.notifSer.success(
                'Success',
                'Announcement Deleted',
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
            this.spinnerService.hide();
        }, (error) => {
            this.spinnerService.hide();
            this.notifSer.error(
                'Error',
                error.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }

    setPage(page: number) {
        // get pager object from service
        this.pager1 = this.pagerService.getPager(this.Tpager, page);
    }

    setPageOnClick(page: number) {
        this.pager = page;
        this.FilPage = this.pager;
        this.getAnnouncementList();
    }
    TransactionDetails(i){
        this.TransactionActive = i;
    }

    TransactionDetailshide(){
        this.TransactionActive = null;
    }
}



// WEBPACK FOOTER //
// ./src/app/announcement/announcement.component.ts